import React from 'react';
import styled from 'styled-components';

/* =================================================================
   AKTUÁLNY PODCAST — jediné miesto na úpravu odkazov
   -----------------------------------------------------------------
   Spotify (SHOW = ukazuje vždy najnovší diel automaticky, netreba
   nič meniť po novej epizóde):
     verejný odkaz:  https://open.spotify.com/show/2jU246e6bhY0ML848jUHQz
     embed (nižšie): za "open.spotify.com" pridaj "/embed"  ->
                     https://open.spotify.com/embed/show/<ID>
     Pre konkrétny diel namiesto show: .../embed/episode/<ID>
   Apple Podcasts (odkaz na show):
   SPOTIFY_HEIGHT: 352 = plný prehrávač so zoznamom dielov, 152 = kompaktný.
   ================================================================= */
const SPOTIFY_EMBED_SRC =
    'https://open.spotify.com/embed/show/2jU246e6bhY0ML848jUHQz';
const APPLE_PODCASTS_URL =
    'https://podcasts.apple.com/sk/podcast/g%C3%B3ly-a-es%C3%A1-futbalov%C3%A9-anal%C3%BDzy-value-predikcie/id1879616734';
const SPOTIFY_HEIGHT = 352;

const isSet = (url: string) => !!url && !url.includes('REPLACE');

// --- Styled Components ---

const Wrapper = styled.section`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    padding: 0 16px;
    text-align: left;
`;

const Head = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`;

const Label = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #d9540a;
`;

const Free = styled.span`
    font-size: 11px;
    font-weight: 700;
    color: #0e9e6e;
    background: #e5f5ee;
    padding: 4px 9px;
    border-radius: 999px;
`;

const Cta = styled.p`
    font-size: 13.5px;
    font-weight: 700;
    color: #15171b;
    margin: 0 0 10px;
`;

const SpotifyFrame = styled.iframe`
    width: 100%;
    border: 0;
    border-radius: 12px;
    display: block;
`;

const AppleButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    margin-top: 10px;
    padding: 12px;
    background: linear-gradient(120deg, #822be2, #d92bbe);
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    border-radius: 12px;
    text-decoration: none;

    &:hover {
        opacity: 0.92;
    }
`;

const Note = styled.p`
    display: block;
    width: fit-content;
    margin: 12px auto 0;
    font-size: 12px;
    font-weight: 700;
    color: #d9540a;
    background: rgba(217, 84, 10, 0.1);
    padding: 5px 12px;
    border-radius: 999px;
    text-align: center;
`;

const Fallback = styled.div`
    border: 2px dashed #e7e9ed;
    border-radius: 12px;
    padding: 22px;
    text-align: center;
    color: #9aa0aa;
    font-size: 13px;
`;

// --- Component ---

const PodcastWidget: React.FC = () => {
    return (
        <Wrapper>
            <Head>
                <Label>🎧 Aktuálny podcast</Label>
                <Free>🆓 polovica zadarmo</Free>
            </Head>

            <Cta>Počúvaj na Spotify a Apple Podcasts 👇</Cta>

            {isSet(SPOTIFY_EMBED_SRC) ? (
                <SpotifyFrame
                    title="Góly a Esá — podcast (Spotify)"
                    src={SPOTIFY_EMBED_SRC}
                    height={SPOTIFY_HEIGHT}
                    loading="lazy"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                />
            ) : (
                <Fallback>
                    Sem príde Spotify prehrávač — nastav odkaz v
                    <br />
                    <code>src/components/PodcastWidget.tsx</code>
                </Fallback>
            )}

            {isSet(APPLE_PODCASTS_URL) && (
                <AppleButton
                    href={APPLE_PODCASTS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="9" r="2.4" fill="#fff" />
                        <path
                            d="M8.6 18c.4-2.4 1.1-3.8 3.4-3.8s3 1.4 3.4 3.8c.2 1.1-.7 1.5-3.4 1.5s-3.6-.4-3.4-1.5z"
                            fill="#fff"
                        />
                        <path
                            d="M6.8 13.6a6 6 0 1 1 10.4 0"
                            stroke="#fff"
                            strokeWidth="1.5"
                            fill="none"
                            strokeLinecap="round"
                        />
                    </svg>
                    Počúvaj na Apple Podcasts
                </AppleButton>
            )}

            <Note>Plné epizódy nájdeš v prémiovom obsahu.</Note>
        </Wrapper>
    );
};

export default PodcastWidget;
